// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.productList_proxy_container__YoQLI {
  width: 100%;
  border-top: none;
  margin-top: 16px;
  /* label btn*/
  color: var(--font-dark-color);
  font-family: Red Hat Display;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-right: auto;
  /* label btn*/
}
.productList_proxy_container__YoQLI .productList_freeDateLabel__7RDKm {
  padding: 2px 7px 2px 7px;
  color: #4ac46c;
  border-radius: 5px;
  background-color: var(--st-free-label-bg);
  font-size: 13px;
  text-decoration: none;
  text-align: center;
  display: inline-block;
}
.productList_proxy_container__YoQLI .productList_expiredLabel__kv-1O {
  padding: 2px 11px 2px 12px;
  color: #e85454;
  border-radius: 5px;
  background-color: var(--st-expired-label-bg);
  font-size: 13px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
}
.productList_proxy_container__YoQLI .productList_buttons__2R1w- {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: 7px;
}
.productList_proxy_container__YoQLI .productList_view__-4BlH {
  color: var(--font-dark-color);
  background: var(--st-view-btn-bg);
  padding: 3px 10px;
  border-radius: 9px;
  border: none;
  font-size: 15px;
  cursor: pointer;
}
.productList_proxy_container__YoQLI .productList_reset__-mivk {
  color: var(--font-dark-color);
  background: var(--st-view-btn-bg);
  padding: 3px 10px;
  border-radius: 9px;
  border: none;
  font-size: 15px;
  cursor: pointer;
}
.productList_proxy_container__YoQLI .productList_download__EDd5v {
  color: var(--bg-color);
  background: var(--font-color);
  padding: 3px 10px;
  border-radius: 9px;
  border: none;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
}
.productList_proxy_container__YoQLI .productList_proxy_option__uebiD {
  width: 100%;
  display: flex;
  margin-top: 23px;
  margin-bottom: 15px;
}
.productList_proxy_container__YoQLI .productList_proxy_option__uebiD span {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px;
  margin-left: 10px;
  margin-right: auto;
}
.productList_proxy_container__YoQLI .productList_proxy_option__uebiD button {
  line-height: 16px !important;
}
.productList_proxy_container__YoQLI .productList_proxy_option__uebiD button svg {
  top: 35%;
}
.productList_proxy_container__YoQLI .productList_proxy_option__uebiD button:last-child {
  margin-left: 9px;
}
.productList_proxy_container__YoQLI .productList_proxy_option__uebiD button:last-child svg {
  top: 13%;
}
.productList_proxy_container__YoQLI .productList_proxy_list__ocYT7 {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 800px;
  border-radius: 10px;
}
.productList_proxy_container__YoQLI .productList_proxy_list__ocYT7 .productList_mobile__YJN7b {
  display: none;
}
.productList_proxy_container__YoQLI .productList_proxy_list__ocYT7 .productList_mobile__YJN7b .productList_productCardContainer__3lR2n {
  width: 100%;
}
.productList_proxy_container__YoQLI .productList_proxy_list__ocYT7 .productList_mobile__YJN7b .productList_productCardContainer__3lR2n .productList_productCard__4TTSW {
  width: 100%;
  padding: 13px 20px;
  margin-bottom: 11px;
  border-radius: 10px;
  border: 1px solid var(--re-mobile-title-border-bg);
  background-color: var(--bg-color);
}
.productList_proxy_container__YoQLI .productList_proxy_list__ocYT7 .productList_mobile__YJN7b .productList_productCardContainer__3lR2n .productList_productCard__4TTSW .productList_product_head__x2cYt {
  position: relative;
  margin-bottom: 30px;
}
.productList_proxy_container__YoQLI .productList_proxy_list__ocYT7 .productList_mobile__YJN7b .productList_productCardContainer__3lR2n .productList_productCard__4TTSW .productList_product_head__x2cYt .productList_product_headLabel__FUP2a {
  color: #ffa329;
}
.productList_proxy_container__YoQLI .productList_proxy_list__ocYT7 .productList_mobile__YJN7b .productList_productCardContainer__3lR2n .productList_productCard__4TTSW .productList_product_head__x2cYt .productList_product_name__mcAmf {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.productList_proxy_container__YoQLI .productList_proxy_list__ocYT7 .productList_mobile__YJN7b .productList_productCardContainer__3lR2n .productList_productCard__4TTSW .productList_product_head__x2cYt .productList_quantity__xcnqy {
  color: var(--font-dark-color);
  font-weight: 700;
}
.productList_proxy_container__YoQLI .productList_proxy_list__ocYT7 .productList_mobile__YJN7b .productList_productCardContainer__3lR2n .productList_productCard__4TTSW .productList_product_head__x2cYt .productList_quantity_No__Qlrvg {
  color: var(--font-color);
}
.productList_proxy_container__YoQLI .productList_proxy_list__ocYT7 .productList_mobile__YJN7b .productList_productCardContainer__3lR2n .productList_productCard__4TTSW .productList_product_head__x2cYt .productList_right__RVlQZ {
  float: right;
}
.productList_proxy_container__YoQLI .productList_proxy_list__ocYT7 .productList_mobile__YJN7b .productList_productCardContainer__3lR2n .productList_productCard__4TTSW .productList_product_head__x2cYt .productList_day_label__7\\+bo5 {
  font-size: 12px;
  position: absolute;
  top: -17px;
}
.productList_proxy_container__YoQLI .productList_proxy_list__ocYT7 .productList_mobile__YJN7b .productList_productCardContainer__3lR2n .productList_productCard__4TTSW .productList_product_head__x2cYt .productList_expired_label__3TCTW {
  font-size: 12px;
  position: absolute;
  top: -17px;
  right: 0;
}
.productList_proxy_container__YoQLI .productList_proxy_list__ocYT7 .productList_mobile__YJN7b .productList_productCardContainer__3lR2n .productList_productCard__4TTSW .productList_product_head__x2cYt .productList_white__vvslT {
  color: var(--font-color);
}
.productList_proxy_container__YoQLI .productList_proxy_list__ocYT7 .productList_mobile__YJN7b .productList_productCardContainer__3lR2n .productList_productCard__4TTSW .productList_product_head__x2cYt .productList_marginRight__3EC8u {
  margin-right: 6px;
}
.productList_proxy_container__YoQLI .productList_proxy_list__ocYT7 .productList_mobile__YJN7b .productList_productCardContainer__3lR2n .productList_productCard__4TTSW .productList_day__ppvX8 {
  position: relative;
  margin-bottom: 36px;
}
.productList_proxy_container__YoQLI .productList_proxy_list__ocYT7 .productList_mobile__YJN7b .productList_productCardContainer__3lR2n .productList_productCard__4TTSW .productList_location__Npvm7 {
  position: relative;
  margin-bottom: 16px;
}
.productList_proxy_container__YoQLI .productList_proxy_list__ocYT7 .productList_ProductName__hWYHa {
  font-family: Red Hat Display;
  color: #ffa329;
  font-weight: 700;
  line-height: 19.85px;
  font-size: 15px;
}
.productList_proxy_container__YoQLI .productList_proxy_list__ocYT7 .productList_ProductType__eNYXJ {
  font-family: Red Hat Display;
  color: #ffffff;
  font-weight: 700;
  line-height: 19.85px;
  font-size: 15px;
}
.productList_proxy_container__YoQLI .productList_proxy_list__ocYT7 .productList_proxy__r5TGv {
  width: 100%;
  border: 1px solid var(--re-border-color);
  border-radius: 10px;
  display: flex;
  margin-bottom: 10px;
  padding: 8px 7px;
  text-align: left;
  align-items: center;
}
.productList_proxy_container__YoQLI .productList_proxy_list__ocYT7 .productList_proxy__r5TGv th,
.productList_proxy_container__YoQLI .productList_proxy_list__ocYT7 .productList_proxy__r5TGv td {
  color: var(--font-dark-color);
  font-family: Red Hat Display;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-right: auto;
}
.productList_proxy_container__YoQLI .productList_proxy_list__ocYT7 .productList_proxy__r5TGv th .productList_freeDateLabel__7RDKm,
.productList_proxy_container__YoQLI .productList_proxy_list__ocYT7 .productList_proxy__r5TGv td .productList_freeDateLabel__7RDKm {
  padding: 2px 7px 2px 7px;
  color: #4ac46c;
  border-radius: 5px;
  background-color: var(--st-free-label-bg);
  font-size: 13px;
  text-decoration: none;
  text-align: center;
  display: inline-block;
}
.productList_proxy_container__YoQLI .productList_proxy_list__ocYT7 .productList_proxy__r5TGv th .productList_expiredLabel__kv-1O,
.productList_proxy_container__YoQLI .productList_proxy_list__ocYT7 .productList_proxy__r5TGv td .productList_expiredLabel__kv-1O {
  padding: 2px 11px 2px 12px;
  color: #e85454;
  border-radius: 5px;
  background-color: var(--st-expired-label-bg);
  font-size: 13px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
}
.productList_proxy_container__YoQLI .productList_proxy_list__ocYT7 .productList_proxy__r5TGv th .productList_view__-4BlH,
.productList_proxy_container__YoQLI .productList_proxy_list__ocYT7 .productList_proxy__r5TGv td .productList_view__-4BlH {
  color: var(--font-dark-color);
  background: var(--st-view-btn-bg);
  padding: 3px 10px;
  border-radius: 9px;
  border: none;
  font-size: 15px;
  cursor: pointer;
}
.productList_proxy_container__YoQLI .productList_proxy_list__ocYT7 .productList_proxy__r5TGv th .productList_reset__-mivk,
.productList_proxy_container__YoQLI .productList_proxy_list__ocYT7 .productList_proxy__r5TGv td .productList_reset__-mivk {
  color: var(--font-dark-color);
  background: var(--st-view-btn-bg);
  padding: 3px 10px;
  border-radius: 9px;
  border: none;
  font-size: 15px;
  cursor: pointer;
}
.productList_proxy_container__YoQLI .productList_proxy_list__ocYT7 .productList_proxy__r5TGv th .productList_download__EDd5v,
.productList_proxy_container__YoQLI .productList_proxy_list__ocYT7 .productList_proxy__r5TGv td .productList_download__EDd5v {
  color: var(--bg-color);
  background: var(--font-color);
  padding: 3px 10px;
  border-radius: 9px;
  border: none;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
}
.productList_proxy_container__YoQLI .productList_proxy_list__ocYT7 .productList_proxy__r5TGv img {
  cursor: pointer;
}
@media screen and (max-width: 781px) {
  .productList_proxy_container__YoQLI .productList_proxy_list__ocYT7 .productList_proxy_ref__e5RCM {
    display: none;
  }
  .productList_proxy_container__YoQLI .productList_proxy_list__ocYT7 .productList_desktop__47Z4H {
    display: none;
  }
  .productList_proxy_container__YoQLI .productList_proxy_list__ocYT7 .productList_mobile__YJN7b {
    display: block;
  }
}
.productList_proxy_container__YoQLI .productList_proxy_list__ocYT7::-webkit-scrollbar {
  width: 2px;
  height: 7px;
}
.productList_proxy_container__YoQLI .productList_proxy_list__ocYT7::-webkit-scrollbar-thumb {
  background: linear-gradient(316deg, #ffa329 4.43%, #fe7b1c 56.59%, #fc2a01 150.36%);
}
.productList_proxy_container__YoQLI .productList_proxy_list__ocYT7::-webkit-scrollbar-track {
  background-color: var(--bg-color);
}

.productList_proxy_container__YoQLI::-webkit-scrollbar {
  width: 2px;
  height: 7px;
}

.productList_proxy_container__YoQLI::-webkit-scrollbar-thumb {
  background: linear-gradient(316deg, #ffa329 4.43%, #fe7b1c 56.59%, #fc2a01 150.36%);
}

.productList_proxy_container__YoQLI::-webkit-scrollbar-track {
  background-color: var(--bg-color);
}`, "",{"version":3,"sources":["webpack://./src/components/Layouts/productList/productList.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EAEA,aAAA;EACA,6BAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EA8DA,aAAA;AA7DF;AACE;EACE,wBAAA;EACA,cAAA;EACA,kBAAA;EACA,yCAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,qBAAA;AACJ;AAEE;EACE,0BAAA;EACA,cAAA;EACA,kBAAA;EACA,4CAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;AAAJ;AAGE;EACE,aAAA;EACA,eAAA;EACA,sBAAA;EACA,QAAA;AADJ;AAIE;EACE,6BAAA;EACA,iCAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EAEA,eAAA;AAHJ;AAKE;EACE,6BAAA;EACA,iCAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AAHJ;AAME;EACE,sBAAA;EACA,6BAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAJJ;AASE;EACE,WAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;AAPJ;AASI;EACE,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AAPN;AAUI;EACE,4BAAA;AARN;AAUM;EACE,QAAA;AARR;AAYI;EACE,gBAAA;AAVN;AAYM;EACE,QAAA;AAVR;AAeE;EACE,gBAAA;EAGA,kBAAA;EACA,iBAAA;EACA,mBAAA;AAfJ;AAiBI;EACE,aAAA;AAfN;AAgBM;EACE,WAAA;AAdR;AAgBQ;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kDAAA;EACA,iCAAA;AAdV;AAgBU;EACE,kBAAA;EACA,mBAAA;AAdZ;AAgBY;EACE,cAAA;AAdd;AAiBY;EACE,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAfd;AAkBY;EACE,6BAAA;EACA,gBAAA;AAhBd;AAmBY;EACE,wBAAA;AAjBd;AAoBY;EACE,YAAA;AAlBd;AAqBY;EACE,eAAA;EACA,kBAAA;EACA,UAAA;AAnBd;AAsBY;EACE,eAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;AApBd;AAuBY;EACE,wBAAA;AArBd;AAwBY;EACE,iBAAA;AAtBd;AA0BU;EACE,kBAAA;EACA,mBAAA;AAxBZ;AA2BU;EACE,kBAAA;EACA,mBAAA;AAzBZ;AA+BI;EACE,4BAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;AA7BN;AAgCI;EACE,4BAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;AA9BN;AAiCI;EACE,WAAA;EAEA,wCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAhCN;AAkCM;;EAEE,6BAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAhCR;AAkCQ;;EACE,wBAAA;EACA,cAAA;EACA,kBAAA;EACA,yCAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,qBAAA;AA/BV;AAkCQ;;EACE,0BAAA;EACA,cAAA;EACA,kBAAA;EACA,4CAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;AA/BV;AAkCQ;;EACE,6BAAA;EACA,iCAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EAEA,eAAA;AAhCV;AAmCQ;;EACE,6BAAA;EACA,iCAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AAhCV;AAmCQ;;EACE,sBAAA;EACA,6BAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAhCV;AAoCM;EACE,eAAA;AAlCR;AAsCI;EACE;IACE,aAAA;EApCN;EAuCI;IACE,aAAA;EArCN;EAwCI;IACE,cAAA;EAtCN;AACF;AA0CE;EACE,UAAA;EACA,WAAA;AAxCJ;AA2CE;EACE,mFAAA;AAzCJ;AAiDE;EACE,iCAAA;AA/CJ;;AAmDA;EACE,UAAA;EACA,WAAA;AAhDF;;AAmDA;EACE,mFAAA;AAhDF;;AAwDA;EACE,iCAAA;AArDF","sourcesContent":[".proxy_container {\n  width: 100%;\n  border-top: none;\n  margin-top: 16px;\n\n  /* label btn*/\n  color: var(--font-dark-color);\n  font-family: Red Hat Display;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  margin-right: auto;\n\n  .freeDateLabel {\n    padding: 2px 7px 2px 7px;\n    color: #4ac46c;\n    border-radius: 5px;\n    background-color: var(--st-free-label-bg);\n    font-size: 13px;\n    text-decoration: none;\n    text-align: center;\n    display: inline-block;\n  }\n\n  .expiredLabel {\n    padding: 2px 11px 2px 12px;\n    color: #e85454;\n    border-radius: 5px;\n    background-color: var(--st-expired-label-bg);\n    font-size: 13px;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n  }\n\n  .buttons {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: column;\n    gap: 7px;\n  }\n\n  .view {\n    color: var(--font-dark-color);\n    background: var(--st-view-btn-bg);\n    padding: 3px 10px;\n    border-radius: 9px;\n    border: none;\n    font-size: 15px;\n    // font-weight: 700;\n    cursor: pointer;\n  }\n  .reset {\n    color: var(--font-dark-color);\n    background: var(--st-view-btn-bg);\n    padding: 3px 10px;\n    border-radius: 9px;\n    border: none;\n    font-size: 15px;\n    cursor: pointer;\n  }\n\n  .download {\n    color: var(--bg-color);\n    background: var(--font-color);\n    padding: 3px 10px;\n    border-radius: 9px;\n    border: none;\n    font-size: 15px;\n    font-weight: 700;\n    cursor: pointer;\n  }\n\n  /* label btn*/\n\n  .proxy_option {\n    width: 100%;\n    display: flex;\n    margin-top: 23px;\n    margin-bottom: 15px;\n\n    span {\n      color: var(--font-color);\n      font-family: Red Hat Display;\n      font-size: 20px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: 36px;\n      margin-left: 10px;\n      margin-right: auto;\n    }\n\n    button {\n      line-height: 16px !important;\n\n      svg {\n        top: 35%;\n      }\n    }\n\n    button:last-child {\n      margin-left: 9px;\n\n      svg {\n        top: 13%;\n      }\n    }\n  }\n\n  .proxy_list {\n    overflow-y: auto;\n    // min-width: 1300px;\n    // overflow-x: auto;\n    overflow-x: hidden;\n    max-height: 800px;\n    border-radius: 10px;\n\n    .mobile {\n      display: none;\n      .productCardContainer {\n        width: 100%;\n\n        .productCard {\n          width: 100%;\n          padding: 13px 20px;\n          margin-bottom: 11px;\n          border-radius: 10px;\n          border: 1px solid var(--re-mobile-title-border-bg);\n          background-color: var(--bg-color);\n\n          .product_head {\n            position: relative;\n            margin-bottom: 30px;\n\n            .product_headLabel {\n              color: #ffa329;\n            }\n\n            .product_name {\n              color: var(--font-color);\n              font-family: Red Hat Display;\n              font-size: 15px;\n              font-style: normal;\n              font-weight: 700;\n              line-height: normal;\n            }\n\n            .quantity {\n              color: var(--font-dark-color);\n              font-weight: 700;\n            }\n\n            .quantity_No {\n              color: var(--font-color);\n            }\n\n            .right {\n              float: right;\n            }\n\n            .day_label {\n              font-size: 12px;\n              position: absolute;\n              top: -17px;\n            }\n\n            .expired_label {\n              font-size: 12px;\n              position: absolute;\n              top: -17px;\n              right: 0;\n            }\n\n            .white {\n              color: var(--font-color);\n            }\n\n            .marginRight {\n              margin-right: 6px;\n            }\n          }\n\n          .day {\n            position: relative;\n            margin-bottom: 36px;\n          }\n\n          .location {\n            position: relative;\n            margin-bottom: 16px;\n          }\n        }\n      }\n    }\n\n    .ProductName {\n      font-family: Red Hat Display;\n      color: #ffa329;\n      font-weight: 700;\n      line-height: 19.85px;\n      font-size: 15px;\n    }\n\n    .ProductType {\n      font-family: Red Hat Display;\n      color: #ffffff;\n      font-weight: 700;\n      line-height: 19.85px;\n      font-size: 15px;\n    }\n\n    .proxy {\n      width: 100%;\n      // height: 38px;\n      border: 1px solid var(--re-border-color);\n      border-radius: 10px;\n      display: flex;\n      margin-bottom: 10px;\n      padding: 8px 7px;\n      text-align: left;\n      align-items: center;\n\n      th,\n      td {\n        color: var(--font-dark-color);\n        font-family: Red Hat Display;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: normal;\n        margin-right: auto;\n\n        .freeDateLabel {\n          padding: 2px 7px 2px 7px;\n          color: #4ac46c;\n          border-radius: 5px;\n          background-color: var(--st-free-label-bg);\n          font-size: 13px;\n          text-decoration: none;\n          text-align: center;\n          display: inline-block;\n        }\n\n        .expiredLabel {\n          padding: 2px 11px 2px 12px;\n          color: #e85454;\n          border-radius: 5px;\n          background-color: var(--st-expired-label-bg);\n          font-size: 13px;\n          text-align: center;\n          text-decoration: none;\n          display: inline-block;\n        }\n\n        .view {\n          color: var(--font-dark-color);\n          background: var(--st-view-btn-bg);\n          padding: 3px 10px;\n          border-radius: 9px;\n          border: none;\n          font-size: 15px;\n          // font-weight: 700;\n          cursor: pointer;\n        }\n\n        .reset {\n          color: var(--font-dark-color);\n          background: var(--st-view-btn-bg);\n          padding: 3px 10px;\n          border-radius: 9px;\n          border: none;\n          font-size: 15px;\n          cursor: pointer;\n        }\n\n        .download {\n          color: var(--bg-color);\n          background: var(--font-color);\n          padding: 3px 10px;\n          border-radius: 9px;\n          border: none;\n          font-size: 15px;\n          font-weight: 700;\n          cursor: pointer;\n        }\n      }\n\n      img {\n        cursor: pointer;\n      }\n    }\n\n    @media screen and (max-width: 781px) {\n      .proxy_ref {\n        display: none;\n      }\n\n      .desktop {\n        display: none;\n      }\n\n      .mobile {\n        display: block;\n      }\n    }\n  }\n\n  .proxy_list::-webkit-scrollbar {\n    width: 2px;\n    height: 7px;\n  }\n\n  .proxy_list::-webkit-scrollbar-thumb {\n    background: linear-gradient(\n      316deg,\n      #ffa329 4.43%,\n      #fe7b1c 56.59%,\n      #fc2a01 150.36%\n    );\n  }\n\n  .proxy_list::-webkit-scrollbar-track {\n    background-color: var(--bg-color);\n  }\n}\n\n.proxy_container::-webkit-scrollbar {\n  width: 2px;\n  height: 7px;\n}\n\n.proxy_container::-webkit-scrollbar-thumb {\n  background: linear-gradient(\n    316deg,\n    #ffa329 4.43%,\n    #fe7b1c 56.59%,\n    #fc2a01 150.36%\n  );\n}\n\n.proxy_container::-webkit-scrollbar-track {\n  background-color: var(--bg-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"proxy_container": `productList_proxy_container__YoQLI`,
	"freeDateLabel": `productList_freeDateLabel__7RDKm`,
	"expiredLabel": `productList_expiredLabel__kv-1O`,
	"buttons": `productList_buttons__2R1w-`,
	"view": `productList_view__-4BlH`,
	"reset": `productList_reset__-mivk`,
	"download": `productList_download__EDd5v`,
	"proxy_option": `productList_proxy_option__uebiD`,
	"proxy_list": `productList_proxy_list__ocYT7`,
	"mobile": `productList_mobile__YJN7b`,
	"productCardContainer": `productList_productCardContainer__3lR2n`,
	"productCard": `productList_productCard__4TTSW`,
	"product_head": `productList_product_head__x2cYt`,
	"product_headLabel": `productList_product_headLabel__FUP2a`,
	"product_name": `productList_product_name__mcAmf`,
	"quantity": `productList_quantity__xcnqy`,
	"quantity_No": `productList_quantity_No__Qlrvg`,
	"right": `productList_right__RVlQZ`,
	"day_label": `productList_day_label__7+bo5`,
	"expired_label": `productList_expired_label__3TCTW`,
	"white": `productList_white__vvslT`,
	"marginRight": `productList_marginRight__3EC8u`,
	"day": `productList_day__ppvX8`,
	"location": `productList_location__Npvm7`,
	"ProductName": `productList_ProductName__hWYHa`,
	"ProductType": `productList_ProductType__eNYXJ`,
	"proxy": `productList_proxy__r5TGv`,
	"proxy_ref": `productList_proxy_ref__e5RCM`,
	"desktop": `productList_desktop__47Z4H`
};
export default ___CSS_LOADER_EXPORT___;
